import MyBread from '../../components/Breadcrumbs'
import React from 'react'
import HolidayCalendar from 'Calendar/components/HolidayCalendar/HolidayCalendar';
import { Wrapper, PageTitle } from 'styles/styles';

export default function FactoryClosedDates() {
  return (
    <>
      <Wrapper>
        <MyBread />
        <PageTitle>休日区分マスタ</PageTitle>
        <HolidayCalendar></HolidayCalendar>
      </Wrapper>
    </>
  )
}